import getDistance from './getDistance';

import rotatePoint from './rotatePoint';

import segmentsIntr from './segmentsIntr';

import lineIncludedAngle from './lineIncludedAngle';

import hslToRgb from './hslToRgb';

import rgbToHsl from './rgbToHsl';

const DtMath = {
  getDistance,
  rotatePoint,
  segmentsIntr,
  lineIncludedAngle,
  hslToRgb,
  rgbToHsl,
};

export { getDistance, rotatePoint, segmentsIntr, lineIncludedAngle, hslToRgb, rgbToHsl };

export default DtMath;
